import React from "react"
import { Link } from "gatsby";

import "./modalPopPup.css"

import { PageContext } from "../pageContext";

import MapImage from "../images/NbMapLocation.jpg"


const ModalPopup = (props) => (

  <PageContext.Consumer>
  {({ originalPath, language }) => (

  <div>
    <div className="modal fade in" id="myModall" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style={{display:props.style}}>
      <div className="modal-dialog" role="document">
          <div className="modal-content">
              <div className="modal-body">
                  <h2>SELECT YOUR AREA</h2>
                  <div className="mapBox" >
                  <img src={MapImage} alt=""/>
                  
                      <Link to={"/moncton/" + language + originalPath} className="moncton" aria-current="page" itemprop="url"></Link>
                      <Link to={"/fredericton/" + language + originalPath} className="fredericton" aria-current="page" itemprop="url"></Link>
                      <Link to={"/edmundston/" + language + originalPath} className="edmundston" aria-current="page" itemprop="url"></Link>
                      <Link to={"/bathurst/" + language + originalPath} className="bathurst" aria-current="page" itemprop="url"></Link>

                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
)}
</PageContext.Consumer>
)
export default ModalPopup
